import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Skeleton, Progress, Input } from "antd";
import useBehaviorSelectionLoading from "../../../hooks/Tree/useBehaviorSelectionLoading";
import useBehaviorSelectionTreeChecked from "../../../hooks/Tree/useBehaviorSelectionTreeChecked";
import { setConfigSelectedBehavior } from "../../../store/components/MarketExplorer.slice";
import BehaviorTree from "./BehaviorTree";
import TargetSelectionItems from "./TargetSelectionItems";
import MarketExplorerContainer from "./MarketExplorerContainer";
import { dynamicSort } from "../../../utils/MainHelper";
import RenderComponent from "../../General/RenderComponent";
import { checkIfhasSetToDisplayOnly, getModuleCode } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import { useState } from "react";
import useSearchInTree from "../../../hooks/Tree/useSearchInTree";
import TreeProgress from "../../General/TreeProgress";
import useTreeShowLowActivity from "../../General/useTreeShowLowActivity";

function BehaviorSelection({
    targetFocusData = () => { }
}) {
    const dispatch = useDispatch();
    const [searchedText, setsearchedText] = useState("");
    const [treeData, setTreeData] = useState([]);
    const [parsingData, setParsingData] = useState(false);
    const { isLoading, percentage } = useBehaviorSelectionLoading();
    const {
        selectedKeyword, checkedKeys, setselectedKeyword, setcheckedKeys
    } = useBehaviorSelectionTreeChecked(false);
    const {
        configuration: {
            selectedTarget
        }, behaviorTreeData
    } = useSelector((state) => state.marketExplorer);

    const onClick = (item) => {
        dispatch(setConfigSelectedBehavior(item));
    };

    const moduleCode = getModuleCode();

    useEffect(() => {
        if (checkedKeys.length) {
            let find = behaviorTreeData.find((child) => child && child.name === "Target Focus");
            if (find) {
                let newList = checkedKeys.sort(dynamicSort("lvl", true));
                const checkAllRecursive = (items) => {
                    items.forEach((child) => {
                        newList = newList.filter((item) => (item.parentKey !== child.key));
                        const childList = child.children || child.tempChildren;
                        if (childList && childList.length) {
                            checkAllRecursive(childList);
                        }
                    });
                };
                checkAllRecursive([...newList]);
                find = newList;
            }
            targetFocusData(find || []);
        } else {
            targetFocusData([]);
        }
    }, [checkedKeys.length, behaviorTreeData]);


    const isHcp = ["hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "icd10", "expertmedia"].includes(moduleCode);
    useEffect(() => {
        const parseData = async () => {
            setParsingData(true);
            if (isHcp) {
                const filtered = await checkIfhasSetToDisplayOnly(behaviorTreeData.length ? behaviorTreeData.reduce((acc, row) => {
                    if (row && row.name === "Target Focus") {
                        (row.children || row.tempChildren).forEach((child) => {
                            acc.push(child);
                        });
                    }
                    return acc;
                }, []) : [], selectedTarget.code, selectedTarget)
                await setTreeData(filtered);
            } else {
                const filtered = await checkIfhasSetToDisplayOnly(behaviorTreeData, selectedTarget.code, selectedTarget)
                await setTreeData(filtered);
            }
            setParsingData(false)
        }
        parseData();
    }, [isHcp, behaviorTreeData, selectedTarget]);

    const { searchedData, loadingSearch } = useSearchInTree(searchedText, treeData, isHcp);

    const { showLowActivity, lowActComponent } = useTreeShowLowActivity(selectedTarget)

    const toDisplayData = useMemo(() => {
        const display = searchedText ? searchedData : treeData;
        if (!selectedTarget?.code?.includes("mokb")) return display
        if (!(selectedTarget?.code || selectedTarget?.key)?.includes("mokb")) return display
        if (showLowActivity) return display;
        return display.reduce((acc, d) => {
            const children = (d?.children || []).filter(
                (child) => !child.lowActivity
            );
            if (children.length) acc.push(d);
            return acc;
        }, []);
    }, [searchedText, selectedTarget, searchedData, treeData, showLowActivity]);


    const getContent = () => {
        if (isLoading || loadingSearch || parsingData) {
            return (
                <div
                    className="d-flex-col gap-5p"
                    style={{
                        paddingTop: "2mm"
                    }}
                >
                    <Skeleton paragraph={{ rows: 6 }} active shape="round" />
                </div>
            );
        }

        if (!behaviorTreeData.length) {
            return (
                <RenderComponent
                    show
                    emptyProps={{
                        style: { marginTop: "5mm" }
                    }}
                />
            );
        }
        if (isHcp) {
            return (
                <BehaviorTree
                    selectedKeyword={selectedKeyword}
                    setselectedKeyword={setselectedKeyword}
                    checkedKeys={checkedKeys}
                    setcheckedKeys={setcheckedKeys}
                    treeData={toDisplayData}
                    isLoading={isLoading}
                    noCloseTag
                    searchedText={searchedText}
                />
            );
        }
        return (
            <>
                {toDisplayData.map((item) => (<TargetSelectionItems key={item.name} data={item} onClick={onClick} />))}
            </>
        );
    };

    return (
        <div className="reportBuilder-leftside_targets-behavior" style={{ height: isHcp ? "calc(100% - 44mm)" : "calc(100% - 10mm)" }}>
            <MarketExplorerContainer
                className="reportBuilder-leftside_targets-selection"
                title="Target Focus"
                subTitle=""
                search={<>
                    <Input.Search
                        placeholder="Search here..."
                        style={{ width: "100%", margin: "1mm 0" }}
                        value={searchedText}
                        onChange={(e) => {
                            setsearchedText(e.target.value);
                        }}
                        onSearch={(e) => {
                            setsearchedText(e);
                        }}
                        allowClear
                    />
                    {isLoading ? null : lowActComponent}
                </>}
            >
                <TreeProgress percentage={percentage} />
                {getContent()}
            </MarketExplorerContainer>
        </div>
    );
}
export default BehaviorSelection;
